import { Component } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { NgbCollapse, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ApprovalMatrixService } from '../../../Model/ApprovalMatrix/approval-matrix.service';
import { CommonService } from '../../../Model/Common/common.service';
import { IncometaxService } from '../../../Model/Incometax/incometax.service';
import { UserRightService } from '../../../Model/UserRight/user-right.service';
import { CustomDateParserFormatter } from '../../../Util/DateFormat/date-format.service';
import { SessionService } from '../../../Util/Session/session.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { TooltipService } from '../../../Util/Tooltip/tooltip.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DataTablesModule } from 'angular-datatables';
import { LoaderComponent } from '../../../Component/Loader/loader/loader.component';
import { AttachmentComponent } from '../../../Component/Attachment/attachment/attachment.component';
import { AlertWarningComponent } from '../../../Component/Alert/alert-warning/alert-warning.component';
import { AlertSuccessComponent } from '../../../Component/Alert/alert-success/alert-success.component';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';

@Component({
  selector: 'app-tax-investment-detail-approval',
  standalone: true,
  imports: [CommonModule, DataTablesModule, FormsModule, RouterModule, LoaderComponent, NgbCollapse],
  templateUrl: './tax-investment-detail-approval.component.html',
  styleUrl: './tax-investment-detail-approval.component.scss'
})
export class TaxInvestmentDetailApprovalComponent {
  isDisabled: boolean = false;
  isLoad: boolean = true;
  isSuper: boolean = false;//for super admin
  GetID = 0;//1-detail,2-request
  isApprovalLavel = true;
  OpenCard = {
    CardPreviousEmployment: true as any,
    CardEmpTaxDeclarationDetails: true as any,
    CardEmpTaxDeclarationDetails_HRA: true as any,
    CardEmpTaxDeclarationDetails_Others: true as any,
    CardEmpTaxDeclarationDetails_LOP: true as any,
    CardEmpTaxDeclarationDetails_TDS: true as any,
    CardEmpTaxDeclarationDetails_SOP: true as any,
  }
  DetailData = {
    WebESSApprovalRequestTrackingId: null as any,
    TransactionId: null as any,
    IsNewRegime: null,
    FinancialYearStart: null,
    FinancialYearEnd: null,
    RequestDate: null as any,
    EmpMasterId: null,
    EmpCode: null,
    Photo: null,
    EmployeeName: null as any,
    DesignationMasterId: null,
    DesignationName: null,
    BranchName: null,
    ClientLocation: null,
    EmpType: null as any,
    ApprovalStatus: null as any,
  };

  TablesData = {
    TransactionId: null,
    Table: [
      {
        ESS_EmpTaxInvestmentID: null,
        EmpMasterId: null,
        EmpCode: null,
        EmpName: null as any,
        IsNewRegime: null,
        FinancialYearStart: null,
        FinancialYearEnd: null,
        Photo: null,
        ApprovalStatus: null as any
      }
    ],
    ESS_TaxPreviousEmploymentDetails: [{
      ESS_TaxPreviousEmploymentDetailsID: 0,
      ESS_EmpTaxInvestmentID: 0,
      Monthname: null,
      Yearname: null as any,
      Remarks: null as any,
      Basic: null as any,
      DA: null as any,
      HRA: null as any,
      OtherAllowance: null as any,
      GrossAmount: 0,
      PT: null as any,
      PF: null as any,
      TDS: null as any,
      OtherDeduction: null as any,
      NetAmount: 0,
      TimeStamp: null,
      ESS_EmpTaxInvestmentPrevEmployment_Attachment: [{
        ESS_EmpTaxInvestmentPrevEmploymentDetailsId: null,
        Attachment: null,
      }
      ],
    }],
    ESS_EmpTaxInvestmentDetails: [{
      ESS_EmpTaxInvestmentDetailsId: null,
      ESS_EmpTaxInvestmentID: null,
      ESS_TaxSectionMasterId: null,
      SectionCode: null,
      SectionName: null,
      IncomeHead: null,
      SectionDescription: null,
      ESS_TaxSectionDetailId: null,
      SubSectionName: null,
      SubSectionDescription: null,
      LimitApplicable: null,
      MaxLimitAmount: null,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      ESS_EmpTaxInvestmentDetails_Attachment: [{
        ESS_EmpTaxInvestmentDetailsId: null,
        Attachment: null,
      },],
    }],
    ESS_EmpTaxDeclarationDetails_HRA: [{
      ESS_EmpTaxInvestmentDetails_HRAID: null,
      ESS_EmpTaxInvestmentID: null,
      FromDate: null,
      ToDate: null,
      NameOfLandlord: null,
      LandLordPanNo: null,
      Address: null,
      IsMetroCity: null,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      ESS_EmpTaxInvestmentDetails_HRAAttachment: [{
        ESS_EmpTaxInvestmentDetails_HRAId: null,
        Attachment: null,
      }],
    }],
    ESS_EmpTaxDeclarationDetails_LOP: [{
      ESS_EmpTaxInvestmentDetails_LOPID: null,
      ESS_EmpTaxInvestmentID: null,
      AnnualRentReceived: null,
      NetAnnualValue: null,
      StandardDeduction: null,
      RepayingHomeLoanForThisProperty: null,
      PrincipalPaidOnHomeLoan: null,
      MunicipalTaxesPaid: null,
      InterestPaidOnHomeLoan: null,
      NameOfTheLender: null,
      LenderPanNo: null,
      NetIncomeLossFromHouseProperty: null,
      ESS_EmpTaxInvestmentDetails_LOPAttachment: [{
        ESS_EmpTaxInvestmentDetails_LOPId: null,
        Attachment: null,
      }]
    }],
    ESS_EmpTaxDeclarationDetails_Others: [{
      ESS_EmpTaxInvestmentDetails_OthersID: null,
      ESS_EmpTaxInvestmentID: null,
      ESS_TaxSectionDetailId: null,
      SubSectionName: null,
      SubSectionDescription: null,
      LimitApplicable: null,
      MaxLimitAmount: null,
      ProofSubmissionAmount: null,
      ApprovedAmount: null,
      ESS_EmpTaxInvestmentDetails_OthersAttachment: []
    }],
    ESS_EmpTaxDeclarationDetails_TDS: [{
      ESS_EmpTaxInvestmentDetails_TDSID: 0,
      ESS_EmpTaxInvestmentID: 0,
      TDSorTCSPaid: null,
      ChallanNo: null,
      PaymentDate: null as any,
      ESS_EmpTaxInvestmentDetails_TDSAttachment: []
    }],
    ESS_EmpTaxDeclarationDetails_SOP: [{
      ESS_EmpTaxInvestmentDetails_SOPID: 0,
      ESS_EmpTaxInvestmentID: 0,
      AnnualInterestPaidORPayable: null,
      PrincipalRepaymentAmount: null,
      LenderName: null,
      LenderPANNo: null,
      PropertyAddress: null,
      PossessionDate: null as any,
      CoOwnedProperty: null,
      CoOwnerName: null,
      CoOwnerSharePerc: null,
      ESS_EmpTaxInvestmentDetails_SOPAttachment: []
    }],
  };
  updateDate = { SelectType: 'U', ESS_EmpTaxInvestmentId: null, ESS_EmpTaxInvestmentDetailsAmt: [] as any, ESS_EmpTaxInvestmentDetails_HRAAmt: [] as any, ESS_EmpTaxInvestmentDetails_OthersAmt: [] as any };
  Trackings = [];
  TrackingsUser = [];
  user = [] as any;
  Filter = {
    ModuleMasterId: 10,
    WebESSApprovalRequestTrackingId: 0,
    FromDate: null,
    ToDate: null,
    FromDateObj: null as any,
    ToDateObj: null as any,
    EmpMasterId: 0,
    EmpMappingId: 0,
    SelectType1: 'D',
    SelectType: null,
    EmpType: null,
    Remark: null,
    isShowError: false,
  }

  constructor(
    private approvalMatrix: ApprovalMatrixService,
    private route: ActivatedRoute,
    private session: SessionService,
    private toast: ToastService,
    private incometax: IncometaxService,
    private router: Router,
    protected common: CommonService,
    protected dateFormate: CustomDateParserFormatter,
    private modalService: NgbModal,
    protected tooltip: TooltipService,
    private userright: UserRightService
  ) {
    this.common.getPageRights();
    this.user = this.session.GetUserDetails();
    this.route.params.subscribe(params => this.Filter.WebESSApprovalRequestTrackingId = parseInt(params['id']));
    if (window.location.pathname.includes('todo')) {
      this.GetID = 1;
    } else if (window.location.pathname.includes('request')) {
      this.GetID = 2
    }
  }

  ngOnInit(): void {
    if (this.user.UserType == 'E') {
      this.Filter.EmpMappingId = this.user.UserId;
    }
    if (this.GetID == 1) {
      this.ApprovalMatrixRequestGet();
      this.ESS_GetUserRole();
    } else if (this.GetID == 2) {
      //this.ESS_EmpTaxDeclarationSelect('S');
    }
  }

  ApprovalMatrixRequestGet() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet(this.Filter).subscribe({
      next: (response) => {
        if (this.Filter.ModuleMasterId == 10) {
          if (response.Table.length > 0) {
            this.DetailData = response.Table[0];
          } else if (response.Table1.length > 0) {
            this.DetailData = response.Table1[0];
          } else if (response.Table2.length > 0) {
            this.DetailData = response.Table2[0];
          } else if (response.Table3.length > 0) {
            this.DetailData = response.Table3[0];
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        this.ApprovalMatrixRequestGetTracking();
        this.ESS_EmpTaxInvestmentSelect('E');
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ApprovalMatrixRequestGetTracking() {
    this.isDisabled = true;
    this.approvalMatrix.ApprovalMatrixRequestGet({ ModuleMasterId: this.Filter.ModuleMasterId, FromDate: '', ToDate: '', EmpMasterId: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, SelectType1: 'ApprovalStatus', SelectType: '', TransactionId: this.DetailData.TransactionId }).subscribe({
      next: (response) => {
        if (response.Table.length == 0) {
          this.isApprovalLavel = false;
        }
        if (this.common.ToLowerCase(this.DetailData.ApprovalStatus) == 'pending') {
          if (this.user.UserType == 'A') {
            this.TrackingsUser = response.Table.filter((e: any) => e.ApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.ApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          } else if (this.user.UserType == 'E') {
            this.TrackingsUser = response.Table.filter((e: any) => e.EmpApproverId == this.user.UserId);
            this.Trackings = response.Table.filter((e: any) => e.EmpApproverId != this.user.UserId).sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
          }
        } else {
          this.Trackings = response.Table.sort((a: any, b: any) => b['SrNo.'] - a['SrNo.']);
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  ESS_GetUserRole() {
    this.isDisabled = true;
    try {
      this.userright.ESS_GetUserRole({ SelectType: 'S', EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
        next: (response) => {
          if (this.common.ToLowerCase(response.Table[0].UserRole) == 'superadmin') {
            this.isSuper = true;
          }
          this.isDisabled = false;
        },
        complete: () => { },
        error: (error) => {
          this.isDisabled = false;
        },
      });
    } catch (e) {
      this.isDisabled = false;
    }
  }

  ApprovalMatrixRequestProcess(SelectType: string) {
    if (this.TablesData.ESS_EmpTaxInvestmentDetails.filter((e: any) => e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.  (Chapter VI A Details)', type: toastTypeEnum.warning });
    }
    else if (this.TablesData.ESS_EmpTaxDeclarationDetails_HRA.filter((e: any) => e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.  (Are you staying in a rented house?)', type: toastTypeEnum.warning });
    }
    else if (this.TablesData.ESS_EmpTaxDeclarationDetails_Others.filter((e: any) => e.ApprovedAmount < 0).length > 0) {
      this.toast.show({ message: 'Not allow to add approve amount in minus or blank.  (Other Sources of Income)', type: toastTypeEnum.warning });
    } else {
      if (((SelectType == 'Reject' && this.Filter.Remark != '' && this.Filter.Remark != null) || SelectType == 'Approve') || this.isSuper) {
        const modalRef = this.modalService.open(ConfirmationComponent, {
          size: 'md',
          backdrop: 'static',
          centered: true,
          windowClass: 'confirmation-modal'
        });
        modalRef.componentInstance.Message = 'Do you want to ' + SelectType + '?';
        modalRef.result.then((result: any) => {
          if (result) {
            this.isDisabled = true;

            if (this.TablesData.ESS_EmpTaxInvestmentDetails.filter((e: any) => e.DeclaredAmount != e.ApprovedAmount).length > 0 ||
              this.TablesData.ESS_EmpTaxDeclarationDetails_HRA.filter((e: any) => e.DeclaredAmount != e.ApprovedAmount).length > 0 ||
              this.TablesData.ESS_EmpTaxDeclarationDetails_Others.filter((e: any) => e.DeclaredAmount != e.ApprovedAmount).length > 0) {

              this.updateDate.ESS_EmpTaxInvestmentId = this.DetailData.TransactionId;
              this.updateDate.ESS_EmpTaxInvestmentDetailsAmt = [];
              this.updateDate.ESS_EmpTaxInvestmentDetails_HRAAmt = [];
              this.updateDate.ESS_EmpTaxInvestmentDetails_OthersAmt = [];

              this.TablesData.ESS_EmpTaxInvestmentDetails.forEach(element => {
                this.updateDate.ESS_EmpTaxInvestmentDetailsAmt.push(
                  {
                    ESS_EmpTaxInvestmentDetailsID: element.ESS_EmpTaxInvestmentDetailsId,
                    ApprovedAmount: element.ApprovedAmount,
                  }
                );
              });

              this.TablesData.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
                this.updateDate.ESS_EmpTaxInvestmentDetails_HRAAmt.push(
                  {
                    ESS_EmpTaxInvestmentDetails_HRAID: element.ESS_EmpTaxInvestmentDetails_HRAID,
                    ApprovedAmount: element.ApprovedAmount,
                  }
                );
              });

              this.TablesData.ESS_EmpTaxDeclarationDetails_Others.forEach(element => {
                this.updateDate.ESS_EmpTaxInvestmentDetails_OthersAmt.push(
                  {
                    ESS_EmpTaxInvestmentDetails_OthersID: element.ESS_EmpTaxInvestmentDetails_OthersID,
                    ApprovedAmount: element.ApprovedAmount,
                  }
                );
              });

              this.incometax.ESS_TaxInvestmentUpdateAtApproval(this.updateDate).subscribe({
                next: (response) => {
                  if (response.Error_Code == '694') {
                    this.RequestAR(SelectType);
                  } else {
                    const modalRef = this.modalService.open(AlertWarningComponent, {
                      size: 'md',
                      backdrop: 'static',
                      centered: true,
                      windowClass: 'confirmation-modal'
                    });
                    modalRef.componentInstance.Message = response.Error_Message;
                    modalRef.result.then((result: any) => { });
                    this.isDisabled = false;
                  }
                },
                complete: () => { },
                error: (error) => {
                  this.isDisabled = false;
                },
              });
            } else {
              this.RequestAR(SelectType);
            }
          }
        }).catch(() => { });
      } else {
        this.Filter.isShowError = true;
        this.toast.show({ message: 'Please enter remark', type: toastTypeEnum.warning });
      }
    }
  }

  ESS_EmpTaxInvestmentSelect(selecttype: String) {
    this.isDisabled = true;
    this.incometax.ESS_EmpTaxInvestmentSelect({ SelectType: selecttype, ESS_EmpTaxInvestmentID: this.DetailData.TransactionId, EmpMasterId: this.Filter.EmpMasterId, FinancialYearFrom: '', FinancialYearTo: '', IsDraft: false, ApprovalStatus: 'ALL', }).subscribe({
      next: (response) => {
        if (response) {
          this.TablesData.Table = [];
          this.TablesData.ESS_TaxPreviousEmploymentDetails = [];
          this.TablesData.ESS_TaxPreviousEmploymentDetails = [];
          if (response.Table) {
            this.TablesData.Table = response.Table;
            this.TablesData.TransactionId = this.TablesData.Table[0].ESS_EmpTaxInvestmentID;
          }
          if (response.Table3) {
            this.TablesData.ESS_TaxPreviousEmploymentDetails = response.Table3.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentPrevEmployment_Attachment: [] }));
            if (response.Table4 && response.Table4.length > 0) {
              if (response.Table4[0].ESS_EmpTaxInvestmentPrevEmploymentDetailsId != null) {
                this.TablesData.ESS_TaxPreviousEmploymentDetails.forEach(element => {
                  element.ESS_EmpTaxInvestmentPrevEmployment_Attachment = response.Table4.filter((e: any) => e.ESS_EmpTaxInvestmentPrevEmploymentDetailsId == element.ESS_TaxPreviousEmploymentDetailsID);
                });
              }
            }
          }

          if (response.Table1) {
            this.TablesData.ESS_EmpTaxInvestmentDetails = response.Table1.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_Attachment: [] }));
            if (response.Table2 && response.Table2.length > 0) {
              if (response.Table2[0].ESS_EmpTaxInvestmentDetailsId != null) {
                this.TablesData.ESS_EmpTaxInvestmentDetails.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_Attachment = response.Table2.filter((e: any) => e.ESS_EmpTaxInvestmentDetailsId == element.ESS_EmpTaxInvestmentDetailsId);
                });
              }
            }
          }

          if (response.Table5) {
            this.TablesData.ESS_EmpTaxDeclarationDetails_HRA = response.Table5.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_HRAAttachment: [] }));
            if (response.Table6 && response.Table6.length > 0) {
              if (response.Table6[0].ESS_EmpTaxInvestmentDetails_HRAId != null) {
                this.TablesData.ESS_EmpTaxDeclarationDetails_HRA.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_HRAAttachment = response.Table6.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_HRAId == element.ESS_EmpTaxInvestmentDetails_HRAID);
                });
              }
            }
          }

          if (response.Table9) {
            this.TablesData.ESS_EmpTaxDeclarationDetails_LOP = response.Table9.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_LOPAttachment: [] }));
            if (response.Table10 && response.Table10.length > 0) {
              if (response.Table10[0].ESS_EmpTaxInvestmentDetails_LOPId != null) {
                this.TablesData.ESS_EmpTaxDeclarationDetails_LOP.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_LOPAttachment = response.Table10.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_LOPId == element.ESS_EmpTaxInvestmentDetails_LOPID);
                });
              }
            }
          }

          if (response.Table7) {
            this.TablesData.ESS_EmpTaxDeclarationDetails_Others = response.Table7.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_OthersAttachment: [] }));
            if (response.Table8 && response.Table8.length > 0) {
              if (response.Table8[0].ESS_EmpTaxInvestmentDetails_OthersId != null) {
                this.TablesData.ESS_EmpTaxDeclarationDetails_Others.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_OthersAttachment = response.Table8.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_OthersId == element.ESS_EmpTaxInvestmentDetails_OthersID);
                });
              }
            }
          }

          if (response.Table11) {
            this.TablesData.ESS_EmpTaxDeclarationDetails_TDS = response.Table11.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_TDSAttachment: [] }));
            if (response.Table12 && response.Table12.length > 0) {
              if (response.Table12[0].ESS_EmpTaxInvestmentDetails_TDSId != null) {
                this.TablesData.ESS_EmpTaxDeclarationDetails_TDS.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_TDSAttachment = response.Table12.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_TDSId == element.ESS_EmpTaxInvestmentDetails_TDSID);
                });
              }
            }
          }

          if (response.Table13) {
            this.TablesData.ESS_EmpTaxDeclarationDetails_SOP = response.Table13.map((e: any) => ({ ...e, ESS_EmpTaxInvestmentDetails_SOPAttachment: [] }));
            if (response.Table14 && response.Table14.length > 0) {
              if (response.Table14[0].ESS_EmpTaxInvestmentDetails_SOPId != null) {
                this.TablesData.ESS_EmpTaxDeclarationDetails_SOP.forEach(element => {
                  element.ESS_EmpTaxInvestmentDetails_SOPAttachment = response.Table14.filter((e: any) => e.ESS_EmpTaxInvestmentDetails_SOPId == element.ESS_EmpTaxInvestmentDetails_SOPID);
                });
              }
            }
          }
        }
        this.isDisabled = false;
      },
      complete: () => {
        if (selecttype == 'S') {
          this.ApprovalMatrixRequestGetTracking();
        }
      },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  attachmentPopup(index: number, tabNo: number) {
    const modalRef = this.modalService.open(AttachmentComponent, {
      size: 'md',
      backdrop: 'static',
      centered: true,
    });
    modalRef.componentInstance.IsView = true;
    if (tabNo == 1 && this.TablesData.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.TablesData.ESS_TaxPreviousEmploymentDetails[index].ESS_EmpTaxInvestmentPrevEmployment_Attachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 2 && this.TablesData.ESS_EmpTaxInvestmentDetails[index].ESS_EmpTaxInvestmentDetails_Attachment.length > 0) {
      modalRef.componentInstance.Attachments = this.TablesData.ESS_EmpTaxInvestmentDetails[index].ESS_EmpTaxInvestmentDetails_Attachment.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 3 && this.TablesData.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.length > 0) {
      modalRef.componentInstance.TablesData = this.TablesData.ESS_EmpTaxDeclarationDetails_HRA[index].ESS_EmpTaxInvestmentDetails_HRAAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 4 && this.TablesData.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.TablesData.ESS_EmpTaxDeclarationDetails_LOP[index].ESS_EmpTaxInvestmentDetails_LOPAttachment.map(e => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    } else if (tabNo == 5 && this.TablesData.ESS_EmpTaxDeclarationDetails_Others[index].ESS_EmpTaxInvestmentDetails_OthersAttachment.length > 0) {
      modalRef.componentInstance.Attachments = this.TablesData.ESS_EmpTaxDeclarationDetails_Others[index].ESS_EmpTaxInvestmentDetails_OthersAttachment.map((e: any) => ({ 'FileName': e['Attachment'], 'Url': this.common.CompanyParameterValue.HTTPSDownloadLink + '/' + this.common.CompanyParameterValue.ProofAttachment + '/' + e['Attachment'] }));
    }

    modalRef.result.then((result: any) => { })
  }

  RequestAR(SelectType: string) {
    this.isDisabled = true;
    //this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, approvedid: this.DetailData.EmpMasterId, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
    this.approvalMatrix.ApprovalMatrixRequestProcess({ SelectType: SelectType, WebESSApprovalRequestTrackingId: this.DetailData.WebESSApprovalRequestTrackingId, Remark: this.Filter.Remark, EmpMappingId: this.Filter.EmpMappingId, }).subscribe({
      next: (response) => {
        if (response.Error_Code == '49' || response.Error_Code == '50' || response.Error_Code == '51') {
          const modalRef = this.modalService.open(AlertSuccessComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => {
            if (result) {
              this.router.navigate(['/todo/taxinvestment/']);
            }
          });
        } else {
          const modalRef = this.modalService.open(AlertWarningComponent, {
            size: 'md',
            backdrop: 'static',
            centered: true,
            windowClass: 'confirmation-modal'
          });
          modalRef.componentInstance.Message = response.Error_Message;
          modalRef.result.then((result: any) => { });
        }
        this.isDisabled = false;
      },
      complete: () => { },
      error: (error) => {
        this.isDisabled = false;
      },
    });
  }

  Cancel() {
    if (this.GetID == 1) {
      if (this.user.UserType == 'A') {
        this.router.navigate(['/todo/taxinvestment/']);
      } else if (this.user.UserType == 'E') {
        this.router.navigate(['/request/taxinvestment/approval/']);
      }
    } else if (this.GetID == 2) {
      this.router.navigate(['/request/taxinvestment/']);
    }
  }

  onSwitchChange(event: any, cardname: string) {
    if (cardname == "CardPreviousEmployment") {
      this.OpenCard.CardPreviousEmployment = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails") {
      this.OpenCard.CardEmpTaxDeclarationDetails = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_HRA") {
      this.OpenCard.CardEmpTaxDeclarationDetails_HRA = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_Others") {
      this.OpenCard.CardEmpTaxDeclarationDetails_Others = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_LOP") {
      this.OpenCard.CardEmpTaxDeclarationDetails_LOP = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_TDS") {
      this.OpenCard.CardEmpTaxDeclarationDetails_TDS = event.target.checked;
    } else if (cardname == "CardEmpTaxDeclarationDetails_SOP") {
      this.OpenCard.CardEmpTaxDeclarationDetails_SOP = event.target.checked;
    }
  }

  removeError() {
    this.Filter.isShowError = false;
  }
}
